import { isErrorResponse, getErrorFromErrorResponse } from '@standardnotes/responses';
import { Result } from '@standardnotes/domain-core';
export class GetOutboundMessages {
    constructor(messageServer) {
        this.messageServer = messageServer;
    }
    async execute() {
        const response = await this.messageServer.getOutboundUserMessages();
        if (isErrorResponse(response)) {
            return Result.fail(getErrorFromErrorResponse(response).message);
        }
        return Result.ok(response.data.messages);
    }
}
